import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessKey: localStorage.getItem("accessKey") || "", // 添加 accessKey 状态
    token: localStorage.getItem("token") || "", // 添加 token 状态
  },
  mutations: {
    setAccessKey(state, accessKey) {
      // console.log("[ setAccessKey ]", "store/index.js  13 ->", accessKey);
      state.accessKey = accessKey; // 设置 accessKey
      localStorage.setItem("accessKey", accessKey);
    },
    setToken(state, token) {
      state.token = token; // 设置 token
      localStorage.setItem("token", token);
    }
  },
  actions: {
  },
  modules: {
  }
})